import { Injectable } from '@angular/core';
import { MemberStatusOperation } from '../domain/member-status';

export const MEMBER_STATUS_RECOVERY_PREFIX = 'sfRecovery:admin-member-status:';
@Injectable({ providedIn: 'root' })
export class MemberStatusStorage {
  private key(owner: number, studioId: number, memberId: number): string { return `${MEMBER_STATUS_RECOVERY_PREFIX}${owner}:${studioId}:${memberId}`; }
  write(operation: MemberStatusOperation): void {
    const { owner, studioId, memberId, status, phase, memberConfirmed, historyConfirmed } = operation;
    sessionStorage.setItem(this.key(owner, studioId, memberId), JSON.stringify({ owner, studioId, memberId, status, phase, memberConfirmed, historyConfirmed }));
  }
  read(owner: number, studioId: number, memberId: number): MemberStatusOperation | undefined {
    const raw = sessionStorage.getItem(this.key(owner, studioId, memberId));
    if (!raw) return undefined;
    const value = JSON.parse(raw);
    if (!value || value.owner !== owner || value.studioId !== studioId || value.memberId !== memberId || ![0, 1, 2, 3].includes(value.status)
      || !['saving', 'history', 'refreshing', 'unknown', 'partial', 'saved-stale', 'saved'].includes(value.phase) || typeof value.memberConfirmed !== 'boolean' || typeof value.historyConfirmed !== 'boolean') throw new Error('invalid-recovery-record');
    return { ...value, message: '' };
  }
  clear(operation: MemberStatusOperation): void { sessionStorage.removeItem(this.key(operation.owner, operation.studioId, operation.memberId)); }
  members(owner: number, studioId: number): number[] {
    const prefix = `${MEMBER_STATUS_RECOVERY_PREFIX}${owner}:${studioId}:`;
    return Object.keys(sessionStorage).filter(key => key.startsWith(prefix)).map(key => {
      const memberId = Number(key.slice(prefix.length));
      if (!Number.isInteger(memberId) || memberId <= 0) throw new Error('invalid-recovery-key');
      return memberId;
    });
  }
}
